/** Parse a whole-number checkpoint setting without treating an empty field as zero. */
export function parseCheckpointWhole(raw: string, label: string, unit: 'seconds' | 'MiB'): number {
  if (!raw.trim()) throw new Error(`${label} is required; enter a number of ${unit}.`);
  const value = Number(raw);
  if (!Number.isSafeInteger(value) || value < 0)
    throw new Error(`${label} must be a whole number of ${unit}, at least 0.`);
  return value;
}
